import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getUser, getSuccess } from '../../store/selector/auth.selector';
import AuthForm from '../../shared/components/auth/auth-form';
import AuthOtpForm from '../../shared/components/auth/auth-otp-form';
import Layout from '../../shared/components/ui/layout';
import LoginImage from '../../shared/assets/images/authFormLoginImage.svg';
import OTPImage from '../../shared/assets/images/otpImage.svg';

const Login = () => {
  const user = useSelector(getUser);
  const isSuccess = useSelector(getSuccess);
  const navigate = useNavigate();

  const userLoggedIn = () => {
    if (user) {
      if (user.is_hr) {
        navigate('/hr');
      } else {
        navigate('/approvals');
      }
    }
  };

  useEffect(() => {
    userLoggedIn();
  }, []);

  const ShowForm = isSuccess ? <AuthOtpForm /> : <AuthForm />;

  return <Layout Image={isSuccess === true ? OTPImage : LoginImage}>{ShowForm}</Layout>;
};

export default Login;
